import {Tag} from "antd";

export const renderOperationStaffNames = (names: string[]) =>{
  return <div style={{display: 'flex', flexDirection: 'column'}}>
    {names.map((name)=>{
    return <Tag style={{marginBottom: "3px"}}>{name}</Tag>
  })}
  </div>
}